import { ThemeOptions } from "@mui/material";
import { paletteDataDarkMode } from "./themePalette";

const themeComponents = (isLight) => {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          "&.MuiButton-sizeMedium": {
            padding: "6px 16px",
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          "&.MuiAlert-standardWarning": {
            backgroundColor: "#FDF0E6",
            "& .MuiAlert-icon": {
              color: paletteDataDarkMode.warning.main,
            },
            "& .MuiAlert-message": {
              color: "#5F2B01",
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingRight: "26px",
          paddingLeft: "26px",
          gap: "12px",
          minHeight: "0px",
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: "rgba(177, 177, 177, 1)",
          padding: "0 4px",
          whiteSpace: "nowrap",
          minWidth: "auto",
          gap: "6px",
          "&:hover": {
            filter:
              "invert(62%) sepia(94%) saturate(288%) hue-rotate(6deg) brightness(98%) contrast(100%)",
            color: "warning.main",
          },
          "&.Mui-selected": {
            color: "rgba(231, 187, 65, 1)",
            filter:
              "invert(62%) sepia(94%) saturate(288%) hue-rotate(6deg) brightness(98%) contrast(100%)",
          },
          "& .css-g62626": {
            filter:
              "invert(58%) sepia(95%) saturate(16%) hue-rotate(164deg) brightness(96%) contrast(105%)",
          },
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "rgba(151, 158, 178, 1)",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "rgba(46, 48, 52, 1)",
          zIndex: 0,
          height: "38px",
          borderRadius: "6px",
        },
        root: {
          minHeight: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          "& .MuiTabs-flexContainer ": {
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            alignItems: "center",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: "auto",
          height: "38px",
          fontWeight: "normal",
          textTransform: "none",
          zIndex: 1,
          width: "158.25px",
          "&.Mui-selected": {
            backgroundColor: "transparent",
          },
          "&.MuiButtonBase-root": {
            color: "#fff",
          },
          "& .MuiTouchRipple-root": {
            borderRadius: "6px",
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "rgba(231, 187, 65, 1)",
            filter:
              "invert(62%) sepia(94%) saturate(288%) hue-rotate(6deg) brightness(98%) contrast(100%)",
            backgroundColor: "transparent",
          },
          filter:
            "invert(58%) sepia(95%) saturate(16%) hue-rotate(164deg) brightness(96%) contrast(105%)",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTypography-root": {
            fontSize: "12px",
          },
        },
      },
    },
  }
};

export { themeComponents };